import { SET_IS_TEST_REVIEWED, SetTestsAction } from './types'

export const setTeacherTestReview = (payload: boolean): SetTestsAction => ({
  type: SET_IS_TEST_REVIEWED,
  payload,
})
